/**
 * MiniPlayer - 画面下部のミニプレイヤー
 *
 * タップでフルスクリーンプレイヤー（BottomSheet）を開く。
 * 実際の再生は `@/lib/music-audio-engine` が useMusicStore を購読して行う。
 */

import { Music, Pause, Play, SkipForward } from 'lucide-react'

import { AuthImage } from '@/components/ui/auth-image'
import { useMusicStore } from '@/store/useMusicStore'

import { MusicLyricsImportSheet } from './lyrics-import-sheet'
import { MarqueeText } from './marquee-text'
import { MusicPlayerSheet } from './player-sheet'
import { MusicPlaylistPicker } from './playlist-picker'

export const MiniPlayer = () => {
  const track = useMusicStore((s) => s.queue.at(s.currentIndex))
  const isPlaying = useMusicStore((s) => s.isPlaying)
  const togglePlay = useMusicStore((s) => s.togglePlay)
  const playNext = useMusicStore((s) => s.playNext)
  const setPlayerOpen = useMusicStore((s) => s.setPlayerOpen)

  return (
    <>
      <div className="shrink-0 px-3 pb-[env(safe-area-inset-bottom)]">
        <div className="mb-2 flex items-center gap-3 rounded-2xl bg-white/10 px-3 py-2 backdrop-blur">
          <button
            type="button"
            disabled={!track}
            onClick={() => setPlayerOpen(true)}
            className="flex min-w-0 flex-1 items-center gap-3 border-none text-left"
          >
            <span className="block size-10 shrink-0 overflow-hidden rounded-md bg-white/10">
              {track?.thumbnail ? (
                <AuthImage
                  src={track.thumbnail}
                  alt={track.title}
                  className="size-full object-cover"
                  cacheKey={`music-album-${track.productId}`}
                />
              ) : (
                <span className="flex size-full items-center justify-center">
                  <Music size={18} className="text-muted-foreground" />
                </span>
              )}
            </span>

            <span className="block min-w-0 flex-1">
              <MarqueeText text={track?.title ?? '再生していません'} className="text-sm" />
              {track?.artist && <span className="block truncate text-xs text-muted-foreground">{track.artist}</span>}
            </span>
          </button>

          <button
            type="button"
            aria-label={isPlaying ? '一時停止' : '再生'}
            onClick={togglePlay}
            className="shrink-0 border-none"
          >
            {isPlaying ? <Pause size={22} fill="currentColor" /> : <Play size={22} fill="currentColor" />}
          </button>
          <button type="button" aria-label="次の曲" onClick={playNext} className="shrink-0 border-none">
            <SkipForward size={22} fill="currentColor" />
          </button>
        </div>
      </div>

      <MusicPlayerSheet />
      <MusicPlaylistPicker />
      <MusicLyricsImportSheet />
    </>
  )
}
